document.addEventListener('DOMContentLoaded', () => {
  const bodyStyleBtn = document.querySelectorAll('.showroom-body-style');

  bodyStyleBtn.forEach(btn => {
    btn.addEventListener('click', () => {
        // Styles For Body Style Selector
        bodyStyleBtn.forEach(btn => {
          btn.classList.add('border-primary-dark', 'text-black', 'border-2');
          btn.classList.remove('bg-primary-dark', 'text-white');
        })

        btn.classList.add('bg-primary-dark', 'text-white');
        btn.classList.remove('border-primary-dark', 'text-black', 'border-2');

        // Filter Logic
        let selectedFilter = btn.getAttribute('data-filter');
        let itemsToHide = document.querySelectorAll(`.showroom-model-box-container .showroom-model:not([data-filter*='${selectedFilter}'])`);
        let itemsToShow = document.querySelectorAll(`.showroom-model-box-container [data-filter*='${selectedFilter}']`);

        if (selectedFilter == 'all') {
          itemsToHide = [];
          itemsToShow = document.querySelectorAll('.showroom-model-box-container [data-filter]');
        }

        itemsToHide.forEach(el => {
          jQuery(el).fadeOut("fast");
          //el.classList.add('hide', 'hidden');
          //el.classList.remove('show');
          // We hide the content section to improve the animation effect.
          //el.children[0].children[1].classList.add('hidden')
        });

        setTimeout(() => {
          itemsToShow.forEach(el => {
            jQuery(el).fadeIn("fast");
            //el.classList.remove('hide', 'hidden');
            //el.classList.add('show');
            //el.children[0].children[1].classList.remove('hidden')
          });
        }, 200);


    });
  });


  /* Adding an event listener to the buttons in the body style selector. When the button is clicked, it
  will scroll to the showroom models container. */
  let bodyStyleButtons = document.querySelectorAll('.body-style-container > button')

  bodyStyleButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      window.location.href = '#showroom-models-container';
    })
  })
});
